import { EuiFlexGroup, EuiFlexItem } from "@elastic/eui";
import { AddonPurchaseCard } from "components/addons/AddonPurchaseCard";
import { AddonDetails } from "../../api/entities/Addon";
import { ProductDetails } from "api/entities/Product";

export interface IAddonsPanelViewer {
  addons: AddonDetails[];
  onAddonRemoveClick?: (addon: AddonDetails) => void;
  productGroupId: string;
  productDetails: ProductDetails;
  onCustomizableAddonUpdated?: (
    addonDetailsId: string,
    startDate?: string,
    contractLength?: number,
  ) => void;
}

export const AddonsCardViewer: React.FC<IAddonsPanelViewer> = (props) => {
  const addonGroups = props.addons.reduce(
    (acc: Record<string, AddonDetails[]>, a) => {
      if (!acc[a.id]) {
        acc[a.id] = [];
      }
      acc[a.id].push(a);
      return acc;
    },
    {},
  );

  const onAddonRemoved = (addon: AddonDetails) => {
    props.onAddonRemoveClick?.(addon);
  };

  return (
    <EuiFlexGroup>
      {Object.values(addonGroups).map((group) => {
        const addon = group[0];
        return (
          <EuiFlexItem grow={false}>
            <AddonPurchaseCard
              addon={addon}
              quantity={group.length}
              onRemove={() => onAddonRemoved(addon)}
              productGroupId={props.productGroupId}
              onCustomizableAddonUpdated={props.onCustomizableAddonUpdated}
            />
          </EuiFlexItem>
        );
      })}
    </EuiFlexGroup>
  );
};
